
import Profile2user from "../../../assets/filled/Profile2user.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function Profile2userIcon({ className, dataTestid = "Profile2userIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <Profile2user data-testid={dataTestid} className={classes} {...rest} />
  );
}
